<h2 class="title" (click)="clicked.emit()">
  {{ title() }}
</h2>

<div class="content">
  <ng-content></ng-content>
</div>
